<template>
  <a :href="$t(`links.${citationId}`)" target="_blank" rel="noopener">
    <b-icon icon="open-in-new" size="is-small" />
    {{ $t(`rechtstexte.citations.${citationId}`) }}
  </a>
</template>

<script setup lang="ts">
import { BIcon } from 'buefy'

defineProps<{ citationId: string }>()
</script>
